<div class="checkerboard inline-flex h-6 w-6 cursor-pointer rounded-full">
  <span
    class="flex h-6 w-6 items-center justify-center rounded-full text-xs font-medium"
    [ngStyle]="{
      'background-color': backgroundColour(),
      color: colour() || white
    }"
  >
    @if (mode() === statusIndicatorMode.Icon) {
      <mat-icon class="icon-sm">
        {{ icon() ?? '' }}
      </mat-icon>
    } @else {
      {{ character() ?? '' }}
    }
  </span>
</div>
